import { Suspense, lazy } from "react";

import { isProduction } from "@citrine/configuration";
import type { IConfiguration } from "@citrine/resources/configuration";
import type { IUser } from "@citrine/resources/user";

const LazyIntegrations = lazy(() =>
  import(".")
    // if the import fails, return a non-resolving Promise to ignore the failure
    // and prevent crashing
    .catch(() => new Promise(() => {}))
);

export default function Integrations({
  me,
  runtimeConfig,
}: {
  me: IUser;
  runtimeConfig: IConfiguration;
}) {
  return isProduction ? (
    <Suspense fallback={null}>
      <LazyIntegrations me={me} runtimeConfig={runtimeConfig} />
    </Suspense>
  ) : null;
}
